import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-compras',
  templateUrl: './textocompras.component.html',
  styleUrls: ['./textocompras.component.css']
})
export class TextoComprasComponent implements OnInit {

    @Input() idcategory:string;
    public textoSuministradorCompras:boolean;
    public textoAsociacionCompras:boolean;
    public textoAprovechadorCompras:boolean;
    public textoPropietario:boolean;

  constructor() {
      this.textoAprovechadorCompras=false;
      this.textoAsociacionCompras=false;
      this.textoSuministradorCompras=false;
      this.textoPropietario=false;
   }

  ngOnInit() {
    this.selectTextBuy();
  }

  public selectTextBuy(){
    if(this.idcategory==='1'){
        this.textoSuministradorCompras=true;
      }else if(this.idcategory==='2'){
        this.textoAsociacionCompras=true;
      }else if(this.idcategory==='3'){
        this.textoAprovechadorCompras=true;
      }else if(this.idcategory === '4'){
        this.textoPropietario=true;
      }
  }

}